import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";
import { validate, ValidationCallback } from "validation/validate";

type Params = {
	defaultDisplayName: string | undefined;
};

type Output = {
	user: { uid: string; displayName: string; hasAcceptedTerms: boolean };
};

const flagValidationErrors: ValidationCallback<Output> = (
	input,
	{ flag, checkField },
	auth
) => {
	const doValidate: ValidationCallback<Output["user"]> = (
		input,
		utils,
		auth
	) => {
		const { checkField } = utils;

		checkField("uid", { type: "string" });
		checkField("displayName", { type: "string" });
		checkField("hasAcceptedTerms", { type: "boolean" });
	};
	validate(input.user, {
		doValidate,
		auth,
		withErrors: errors => {
			flag("user", JSON.stringify(errors));
		}
	});
};

export const signIn = makeSubmitData<Params, Output>(
	"signIn",
	flagValidationErrors
);
